export default {
  common: {
    notification: 'Notifications',
    pushNotification: 'Live Notifications',
    markAllAsRead: 'Mark all as read',
    clearAll: 'Clear all',
    noNotifications: 'No notifications',
    remove: 'Dismiss',
    filterAll: 'All',
    filterPayments: 'Payments',
    filterInvoices: 'Invoices',
    filterUnread: 'Unread',
    clickToSearch: 'Click to search in Billing',
  },
  tip: {
    unreadNotification: 'You have {count} unread notification(s)',
    pushNotification: 'Show real-time updates for payments and invoices',
  },
};
